// extracted by mini-css-extract-plugin
export default {"productGrid":"h1-z","centerLink":"i1-z","productSection":"j1-z","item":"k1-z","ctaButton":"l1-z"};